module.exports = __webpack_public_path__ + "static/img/reset-64px.1991431f.png";